<script>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import AppLayout from '@/layouts/AppLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { useCurrency } from '@/composables/useCurrency'

export default {
  name: 'App',
  components: {
    AppLayout,
    AuthLayout
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const { fetchRate } = useCurrency()

    watch(
      () => store.getters['auth/user'],
      (user) => {
        if (user) fetchRate().catch(() => {})
      },
      { immediate: true }
    )

    const currentLayout = computed(() => {
      return route.meta?.layout || 'default'
    })

    const layoutComponent = computed(() => {
      switch (currentLayout.value) {
        case 'auth':
          return 'AuthLayout'
        case 'default':
        default:
          return 'AppLayout'
      }
    })

    return {
      layoutComponent
    }
  }
}
</script>

<template>
  <div id="app">
    <component :is="layoutComponent">
      <router-view />
    </component>
  </div>
</template>

<style>
#app {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>
